"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var query_utils_1 = require("./query-utils");
var utils_1 = require("./utils");
var jsbi_1 = __importDefault(require("jsbi"));
var crypto_js_1 = __importDefault(require("crypto-js"));
var Status;
(function (Status) {
    // NetMD Protocol return status (first byte of request)
    Status[Status["control"] = 0] = "control";
    Status[Status["status"] = 1] = "status";
    Status[Status["specificInquiry"] = 2] = "specificInquiry";
    Status[Status["notify"] = 3] = "notify";
    Status[Status["generalInquiry"] = 4] = "generalInquiry";
    //  ... (first byte of response)
    Status[Status["notImplemented"] = 8] = "notImplemented";
    Status[Status["accepted"] = 9] = "accepted";
    Status[Status["rejected"] = 10] = "rejected";
    Status[Status["inTransition"] = 11] = "inTransition";
    Status[Status["implemented"] = 12] = "implemented";
    Status[Status["changed"] = 13] = "changed";
    Status[Status["interim"] = 15] = "interim";
})(Status || (Status = {}));
var Action;
(function (Action) {
    Action[Action["play"] = 117] = "play";
    Action[Action["pause"] = 125] = "pause";
    Action[Action["fastForward"] = 57] = "fastForward";
    Action[Action["rewind"] = 73] = "rewind";
})(Action || (Action = {}));
var Track;
(function (Track) {
    Track[Track["previous"] = 2] = "previous";
    Track[Track["next"] = 32769] = "next";
    Track[Track["restart"] = 1] = "restart";
})(Track || (Track = {}));
var DiscFormat;
(function (DiscFormat) {
    DiscFormat[DiscFormat["lp4"] = 0] = "lp4";
    DiscFormat[DiscFormat["lp2"] = 2] = "lp2";
    DiscFormat[DiscFormat["spMono"] = 4] = "spMono";
    DiscFormat[DiscFormat["spStereo"] = 6] = "spStereo";
})(DiscFormat = exports.DiscFormat || (exports.DiscFormat = {}));
var Wireformat;
(function (Wireformat) {
    Wireformat[Wireformat["pcm"] = 0] = "pcm";
    Wireformat[Wireformat["l105kbps"] = 144] = "l105kbps";
    Wireformat[Wireformat["lp2"] = 148] = "lp2";
    Wireformat[Wireformat["lp4"] = 168] = "lp4";
})(Wireformat = exports.Wireformat || (exports.Wireformat = {}));
var Encoding;
(function (Encoding) {
    Encoding[Encoding["sp"] = 144] = "sp";
    Encoding[Encoding["lp2"] = 146] = "lp2";
    Encoding[Encoding["lp4"] = 147] = "lp4";
})(Encoding = exports.Encoding || (exports.Encoding = {}));
var Channels;
(function (Channels) {
    Channels[Channels["mono"] = 1] = "mono";
    Channels[Channels["stereo"] = 0] = "stereo";
})(Channels = exports.Channels || (exports.Channels = {}));
var ChannelCount;
(function (ChannelCount) {
    ChannelCount[ChannelCount["mono"] = 1] = "mono";
    ChannelCount[ChannelCount["stereo"] = 2] = "stereo";
})(ChannelCount = exports.ChannelCount || (exports.ChannelCount = {}));
var TrackFlag;
(function (TrackFlag) {
    TrackFlag[TrackFlag["protected"] = 3] = "protected";
    TrackFlag[TrackFlag["unprotected"] = 0] = "unprotected";
})(TrackFlag = exports.TrackFlag || (exports.TrackFlag = {}));
var DiscFlag;
(function (DiscFlag) {
    DiscFlag[DiscFlag["writable"] = 16] = "writable";
    DiscFlag[DiscFlag["writeProtected"] = 64] = "writeProtected";
})(DiscFlag = exports.DiscFlag || (exports.DiscFlag = {}));
exports.FrameSize = (_a = {},
    _a[Wireformat.pcm] = 2048,
    _a[Wireformat.lp2] = 192,
    _a[Wireformat.l105kbps] = 152,
    _a[Wireformat.lp4] = 96,
    _a);
// https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
// I could have used the make-error library
var NetMDError = /** @class */ (function (_super) {
    __extends(NetMDError, _super);
    function NetMDError(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, NetMDError.prototype);
        return _this;
    }
    return NetMDError;
}(Error));
var NetMDNotImplemented = /** @class */ (function (_super) {
    __extends(NetMDNotImplemented, _super);
    function NetMDNotImplemented(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, NetMDNotImplemented.prototype);
        return _this;
    }
    return NetMDNotImplemented;
}(NetMDError));
var NetMDRejected = /** @class */ (function (_super) {
    __extends(NetMDRejected, _super);
    function NetMDRejected(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, NetMDRejected.prototype);
        return _this;
    }
    return NetMDRejected;
}(NetMDError));
var NetMDInterface = /** @class */ (function () {
    function NetMDInterface(netMd, logger) {
        var _a;
        this.netMd = netMd;
        this.logger = logger;
        this.logger = (_a = logger) === null || _a === void 0 ? void 0 : _a.child({ class: 'NetMDInterface' });
    }
    NetMDInterface.prototype.sendQuery = function (query, test, acceptInterim) {
        if (test === void 0) { test = false; }
        if (acceptInterim === void 0) { acceptInterim = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendCommand(query, test)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.readReply(acceptInterim)];
                }
            });
        });
    };
    NetMDInterface.prototype.sendCommand = function (query, test) {
        if (test === void 0) { test = false; }
        return __awaiter(this, void 0, void 0, function () {
            var statusByte;
            return __generator(this, function (_a) {
                if (test) {
                    statusByte = new Uint8Array([Status.specificInquiry]).buffer;
                }
                else {
                    statusByte = new Uint8Array([Status.control]).buffer;
                }
                this.netMd.sendCommand(utils_1.concatArrayBuffers(statusByte, query));
                return [2 /*return*/];
            });
        });
    };
    NetMDInterface.prototype.sendHandshake = function (handshake) {
        return __awaiter(this, void 0, void 0, function () {
            var hs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hs = query_utils_1.formatQuery(handshake);
                        return [4 /*yield*/, this.sendQuery(hs)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.waitForSync = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var currentAttempt, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        currentAttempt = 0;
                        _c.label = 1;
                    case 1:
                        if (!(currentAttempt < NetMDInterface.maxSyncAttempts)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.netMd.getReplyLength()];
                    case 2:
                        data = (_c.sent()).data;
                        if (data && data.getUint32(0) === 0) {
                            return [3 /*break*/, 4];
                        }
                        else {
                            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug({ method: 'waitForSync', result: data });
                        }
                        currentAttempt += 1;
                        return [4 /*yield*/, utils_1.sleep(NetMDInterface.syncRetryIntervalInMs * (Math.pow(2, currentAttempt) - 1))];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 1];
                    case 4:
                        if (currentAttempt >= NetMDInterface.maxSyncAttempts) {
                            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.warn({ method: 'waitForSync', result: 'too many tries without success' });
                        }
                        return [2 /*return*/, currentAttempt < NetMDInterface.maxSyncAttempts];
                }
            });
        });
    };
    NetMDInterface.prototype.readReply = function (acceptInterim) {
        if (acceptInterim === void 0) { acceptInterim = false; }
        return __awaiter(this, void 0, void 0, function () {
            var currentAttempt, data, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentAttempt = 0;
                        _a.label = 1;
                    case 1:
                        if (!(currentAttempt < NetMDInterface.maxInterimReadAttempts)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.netMd.readReply()];
                    case 2:
                        (data = (_a.sent()).data);
                        if (data === undefined) {
                            throw new Error('unexpected undefined value in readReply');
                        }
                        status = data.getUint8(0);
                        if (!(status === Status.notImplemented)) return [3 /*break*/, 3];
                        throw new NetMDNotImplemented('Not implemented');
                    case 3:
                        if (!(status === Status.rejected)) return [3 /*break*/, 4];
                        throw new NetMDRejected('Rejected');
                    case 4:
                        if (!(status === Status.interim && !acceptInterim)) return [3 /*break*/, 6];
                        return [4 /*yield*/, utils_1.sleep(NetMDInterface.interimResponseRetryIntervalInMs * (Math.pow(2, currentAttempt) - 1))];
                    case 5:
                        _a.sent();
                        currentAttempt += 1;
                        return [3 /*break*/, 1]; // Retry
                    case 6:
                        if ([Status.accepted, Status.implemented, Status.interim].indexOf(status) < -1) {
                            throw new NetMDNotImplemented("Unknown return status: " + status);
                        }
                        else {
                            return [3 /*break*/, 8]; // Success!
                        }
                        _a.label = 7;
                    case 7: return [3 /*break*/, 1];
                    case 8:
                        if (currentAttempt >= NetMDInterface.maxInterimReadAttempts) {
                            throw new NetMDRejected('Max attempts read attempts for interim status reached');
                        }
                        return [2 /*return*/, data.buffer.slice(1)];
                }
            });
        });
    };
    NetMDInterface.prototype.acquire = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('ff 010c ffff ffff ffff ffff ffff ffff');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        query_utils_1.scanQuery(reply, 'ff 010c ffff ffff ffff ffff ffff ffff');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.release = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('ff 0100 ffff ffff ffff ffff ffff ffff');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        query_utils_1.scanQuery(reply, 'ff 0100 ffff ffff ffff ffff ffff ffff');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.getStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendHandshake('1808 8000 0100')];
                    case 1:
                        _a.sent();
                        query = query_utils_1.formatQuery('1809 8001 0230 8800 0030 8804 00 ff00 00000000');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1809 8001 0230 8800 0030 8804 00 1000 00090000 %x');
                        return [2 /*return*/, res[0]];
                }
            });
        });
    };
    NetMDInterface.prototype.isDiscPresent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStatus()];
                    case 1:
                        status = _a.sent();
                        return [2 /*return*/, status[4] === 0x40];
                }
            });
        });
    };
    NetMDInterface.prototype.getOperatingStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // WARNING: Does not work for all devices. See https://github.com/cybercase/webminidisc/issues/21
                    return [4 /*yield*/, this.sendHandshake('1808 8000 0100')];
                    case 1:
                        // WARNING: Does not work for all devices. See https://github.com/cybercase/webminidisc/issues/21
                        _a.sent();
                        query = query_utils_1.formatQuery('1809 8001 0330 8802 0030 8805 0030 8806 00 ff00 00000000');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1809 8001 0330 8802 0030 8805 0030 8806 00 1000 00%?0000 0006 8806 0002 %w')[0];
                        return [2 /*return*/, jsbi_1.default.toNumber(res)];
                }
            });
        });
    };
    NetMDInterface.prototype._getPlaybackStatus = function (p1, p2) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1809 8001 0330 %w 0030 8805 0030 %w 00 ff00 00000000', p1, p2);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1809 8001 0330 %?%? %?%? %?%? %?%? %?%? %? 1000 00%?0000 %x');
                        return [2 /*return*/, res[0]];
                }
            });
        });
    };
    NetMDInterface.prototype.getPlaybackStatus1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._getPlaybackStatus(0x8801, 0x8807)];
            });
        });
    };
    NetMDInterface.prototype.getPlaybackStatus2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._getPlaybackStatus(0x8802, 0x8806)];
            });
        });
    };
    NetMDInterface.prototype.getPosition = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, err_1, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1809 8001 0430 8802 0030 8805 0030 0003 0030 0002 00 ff00 00000000');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof NetMDRejected) {
                            return [2 /*return*/, null];
                        }
                        else {
                            throw err_1;
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        result = query_utils_1.scanQuery(reply, "1809 8001 0430 %?%? %?%? %?%? " + "%?%? %?%? %?%? %?%? %? %?00 00%?0000 " + "000b 0002 0007 00 %w %b %b %b %b");
                        result[0] = jsbi_1.default.toNumber(result[0]);
                        result[1] = query_utils_1.BCD2int(jsbi_1.default.toNumber(result[1]));
                        result[2] = query_utils_1.BCD2int(jsbi_1.default.toNumber(result[2]));
                        result[3] = query_utils_1.BCD2int(jsbi_1.default.toNumber(result[3]));
                        result[4] = query_utils_1.BCD2int(jsbi_1.default.toNumber(result[4]));
                        return [2 /*return*/, result];
                }
            });
        });
    };
    NetMDInterface.prototype._play = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('18c3 ff %b 000000', action);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        query_utils_1.scanQuery(reply, '18c3 00 %b 000000');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.play = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._play(Action.play)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.fast_forward = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._play(Action.fastForward)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.rewind = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._play(Action.rewind)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.pause = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._play(Action.pause)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('18c5 ff 00000000');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        query_utils_1.scanQuery(reply, '18c5 00 00000000');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.gotoTrack = function (track) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1850 ff010000 0000 %w', track);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1850 00010000 0000 %w')[0];
                        return [2 /*return*/, jsbi_1.default.toNumber(res)];
                }
            });
        });
    };
    NetMDInterface.prototype.gotoTime = function (track, hour, minute, second, frame) {
        if (hour === void 0) { hour = 0; }
        if (minute === void 0) { minute = 0; }
        if (second === void 0) { second = 0; }
        if (frame === void 0) { frame = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1850 ff000000 0000 %w %b%b%b%b', track, query_utils_1.int2BCD(hour), query_utils_1.int2BCD(minute), query_utils_1.int2BCD(second), query_utils_1.int2BCD(frame));
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1850 00000000 %?%? %w %b%b%b%b');
                        return [2 /*return*/, res.map(function (j) { return jsbi_1.default.toNumber(j); })];
                }
            });
        });
    };
    NetMDInterface.prototype._trackChange = function (direction) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1850 ff10 00000000 %w', direction);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        return [2 /*return*/, query_utils_1.scanQuery(reply, '1850 0010 00000000 %?%?')];
                }
            });
        });
    };
    NetMDInterface.prototype.nextTrack = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._trackChange(Track.next)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.previousTrack = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._trackChange(Track.previous)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.restartTrack = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._trackChange(Track.restart)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.eraseDisc = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1840 ff 0000');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        query_utils_1.scanQuery(reply, '1840 00 0000');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.syncTOC = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1808 10180200 00');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        query_utils_1.scanQuery(reply, '1808 10180200 00');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.cacheTOC = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1808 10180203 00');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        query_utils_1.scanQuery(reply, '1808 10180203 00');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.getDiscFlags = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1806 01101000 ff00 0001000b');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1806 01101000 1000 0001000b %b');
                        return [2 /*return*/, jsbi_1.default.toNumber(res[0])];
                }
            });
        });
    };
    NetMDInterface.prototype.getTrackCount = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res1, data, res2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.sendHandshake('180810 1001 0100')];
                    case 1:
                        _b.sent();
                        query = query_utils_1.formatQuery('1806 02101001 3000 1000 ff00 00000000');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _b.sent();
                        res1 = query_utils_1.scanQuery(reply, '1806 02101001 %?%? %?%? 1000 00%?0000 %x');
                        data = String.fromCharCode.apply(String, __spread(res1[0]));
                        utils_1.assert(data.length === 6, "Expected length === 6 for data");
                        utils_1.assert(data.substring(0, 5) === "\0\u0010\0\u0002\0", "Wrong header in data response");
                        res2 = data.charCodeAt(5);
                        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug({ method: "getTrackCount", result: res2 });
                        return [2 /*return*/, res2];
                }
            });
        });
    };
    NetMDInterface.prototype._getDiscTitle = function (wchar) {
        if (wchar === void 0) { wchar = false; }
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var wcharValue, done, remaining, total, result, chunkSize, chunk, query, reply, res_1, res_2, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (wchar) {
                            wcharValue = 1;
                        }
                        else {
                            wcharValue = 0;
                        }
                        done = 0;
                        remaining = 0;
                        total = 1;
                        result = [];
                        _b.label = 1;
                    case 1:
                        if (!(done < total)) return [3 /*break*/, 3];
                        query = query_utils_1.formatQuery('1806 02201801 00%b 3000 0a00 ff00 %w%w', wcharValue, remaining, done);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _b.sent();
                        if (remaining === 0) {
                            res_1 = query_utils_1.scanQuery(reply, '1806 02201801 00%? 3000 0a00 1000 %w0000 %?%?000a %w %*');
                            chunkSize = jsbi_1.default.toNumber(res_1[0]);
                            total = jsbi_1.default.toNumber(res_1[1]);
                            chunk = utils_1.decodeFromSJIS(res_1[2]);
                            chunkSize -= 6;
                        }
                        else {
                            res_2 = query_utils_1.scanQuery(reply, '1806 02201801 00%? 3000 0a00 1000 %w%?%? %*');
                            chunkSize = jsbi_1.default.toNumber(res_2[0]);
                            chunk = utils_1.decodeFromSJIS(res_2[1]);
                        }
                        result.push(chunk);
                        done += chunkSize;
                        remaining = total - done;
                        return [3 /*break*/, 1];
                    case 3:
                        res = result.join('');
                        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug({ method: "_getDiscTitle", result: res });
                        return [2 /*return*/, res];
                }
            });
        });
    };
    NetMDInterface.prototype.getDiscTitle = function (wchar) {
        if (wchar === void 0) { wchar = false; }
        return __awaiter(this, void 0, void 0, function () {
            var title, delim, titleMarker, firstEntry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getDiscTitle(wchar)];
                    case 1:
                        title = _a.sent();
                        delim = wchar ? '／／' : '//';
                        titleMarker = wchar ? '０；' : '0;';
                        if (title.endsWith(delim)) {
                            firstEntry = title.split(delim)[0];
                            if (firstEntry.startsWith(titleMarker)) {
                                title = firstEntry.substring(2);
                            }
                            else {
                                title = '';
                            }
                        }
                        return [2 /*return*/, title];
                }
            });
        });
    };
    NetMDInterface.prototype.getTrackGroupList = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var rawTitle, groupList, trackDict, trackCount, result, rawFullTitle, fullWidthGroupList, _loop_1, _b, _c, _d, groupIndex, group, trackList;
            var e_1, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this._getDiscTitle()];
                    case 1:
                        rawTitle = _f.sent();
                        groupList = rawTitle.split('//');
                        trackDict = {};
                        return [4 /*yield*/, this.getTrackCount()];
                    case 2:
                        trackCount = _f.sent();
                        result = [];
                        return [4 /*yield*/, this._getDiscTitle(true)];
                    case 3:
                        rawFullTitle = _f.sent();
                        fullWidthGroupList = rawFullTitle.split('／／');
                        _loop_1 = function (groupIndex, group) {
                            var _a;
                            if (group === '') {
                                return "continue";
                            }
                            if (group.startsWith('0;') || group.indexOf(';') === -1 || rawTitle.indexOf('//') === -1) {
                                return "continue";
                            }
                            var _b = __read(group.split(';', 1), 1), trackRange = _b[0];
                            var groupName = group.substring(trackRange.length + 1);
                            var fullWidthRange = utils_1.halfWidthToFullWidthRange(trackRange);
                            var fullWidthGroupName = (_a = fullWidthGroupList.find(function (n) { return n.startsWith(fullWidthRange); })) === null || _a === void 0 ? void 0 : _a.substring(fullWidthRange.length + 1);
                            var trackMinStr = void 0, trackMaxStr = void 0;
                            if (trackRange.indexOf('-') >= 0) {
                                _a = __read(trackRange.split('-'), 2), trackMinStr = _a[0], trackMaxStr = _a[1];
                            }
                            else {
                                trackMinStr = trackMaxStr = trackRange;
                            }
                            var _c = __read([Number.parseInt(trackMinStr, 10), Number.parseInt(trackMaxStr, 10)], 2), trackMin = _c[0], trackMax = _c[1];
                            trackMax = Math.min(trackMax, trackCount); // Groups might not updated when a song is deleted
                            utils_1.assert(0 <= trackMin);
                            utils_1.assert(trackMin <= trackMax);
                            var trackList_1 = [];
                            for (var track = trackMin - 1; track < trackMax; track++) {
                                if (track in trackDict) {
                                    throw new Error("Track " + track + " is in 2 groups: " + trackDict[track][0]);
                                }
                                trackDict[track] = [groupName, groupIndex];
                                trackList_1.push(track);
                            }
                            result.push([groupName, (fullWidthGroupName !== null && fullWidthGroupName !== void 0 ? fullWidthGroupName : null), trackList_1]);
                        };
                        try {
                            for (_b = __values(groupList.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                _d = __read(_c.value, 2), groupIndex = _d[0], group = _d[1];
                                _loop_1(groupIndex, group);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        trackList = __spread(Array(trackCount).keys()).filter(function (x) { return !(x in trackDict); });
                        if (trackList.length > 0) {
                            result.unshift([null, null, trackList]);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    NetMDInterface.prototype.getTrackTitle = function (track, wchar) {
        if (wchar === void 0) { wchar = false; }
        return __awaiter(this, void 0, void 0, function () {
            var wcharValue, query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (wchar) {
                            wcharValue = 3;
                        }
                        else {
                            wcharValue = 2;
                        }
                        query = query_utils_1.formatQuery('1806 022018%b %w 3000 0a00 ff00 00000000', wcharValue, track);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1806 022018%? %?%? %?%? %?%? 1000 00%?0000 00%?000a %x');
                        return [2 /*return*/, utils_1.decodeFromSJIS(res[0])];
                }
            });
        });
    };
    NetMDInterface.prototype.setDiscTitle = function (title, wchar) {
        if (wchar === void 0) { wchar = false; }
        return __awaiter(this, void 0, void 0, function () {
            var wcharValue, oldLen, _a, newLength, query, reply;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = utils_1.getLengthAfterEncodingToSJIS;
                        return [4 /*yield*/, this.getDiscTitle()];
                    case 1:
                        oldLen = _a.apply(void 0, [_b.sent()]);
                        newLength = utils_1.getLengthAfterEncodingToSJIS(title);
                        if (wchar) {
                            wcharValue = 1;
                        }
                        else {
                            wcharValue = 0;
                        }
                        return [4 /*yield*/, this.sendHandshake('180810 1801 0100')];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.sendHandshake('180810 1801 0000')];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, this.sendHandshake('180810 1801 0300')];
                    case 4:
                        _b.sent();
                        query = query_utils_1.formatQuery('1807 02201801 00%b 3000 0a00 5000 %w 0000 %w %*', wcharValue, newLength, oldLen, utils_1.encodeToSJIS(title));
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 5:
                        reply = _b.sent();
                        query_utils_1.scanQuery(reply, '1807 02201801 00%? 3000 0a00 5000 %?%? 0000 %?%?');
                        return [4 /*yield*/, this.sendHandshake('180810 1801 0000')];
                    case 6:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.setTrackTitle = function (track, title, wchar) {
        if (wchar === void 0) { wchar = false; }
        return __awaiter(this, void 0, void 0, function () {
            var wcharValue, oldLen, newLen, _a, err_2, query, reply;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (wchar) {
                            wcharValue = 3;
                        }
                        else {
                            wcharValue = 2;
                        }
                        newLen = utils_1.getLengthAfterEncodingToSJIS(title);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = utils_1.getLengthAfterEncodingToSJIS;
                        return [4 /*yield*/, this.getTrackTitle(track)];
                    case 2:
                        oldLen = _a.apply(void 0, [_b.sent()]);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        if (err_2 instanceof NetMDRejected) {
                            oldLen = 0;
                        }
                        else {
                            throw err_2;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, this.sendHandshake('180810 1802 0000')];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, this.sendHandshake('180810 1802 0300')];
                    case 6:
                        _b.sent();
                        query = query_utils_1.formatQuery('1807 022018%b %w 3000 0a00 5000 %w 0000 %w %*', wcharValue, track, newLen, oldLen, utils_1.encodeToSJIS(title));
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 7:
                        reply = _b.sent();
                        query_utils_1.scanQuery(reply, '1807 022018%? %?%? 3000 0a00 5000 %?%? 0000 %?%?');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.eraseTrack = function (track) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1840 ff01 00 201001 %w', track);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.moveTrack = function (source, dest) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendHandshake('180810 1001 0000')];
                    case 1:
                        _a.sent();
                        query = query_utils_1.formatQuery('1843 ff00 00 201001 %w 201001 %w', source, dest);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype._getTrackInfo = function (track, p1, p2) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendHandshake('180810 1001 0100')];
                    case 1:
                        _a.sent();
                        query = query_utils_1.formatQuery('1806 02201001 %w %w %w ff00 00000000', track, p1, p2);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1806 02201001 %?%? %?%? %?%? 1000 00%?0000 %x');
                        return [2 /*return*/, String.fromCharCode.apply(String, __spread(res[0]))];
                }
            });
        });
    };
    NetMDInterface.prototype.getTrackLength = function (track) {
        return __awaiter(this, void 0, void 0, function () {
            var rawValue, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getTrackInfo(track, 0x3000, 0x0100)];
                    case 1:
                        rawValue = _a.sent();
                        result = query_utils_1.scanQuery(utils_1.stringToCharCodeArray(rawValue), '0001 0006 0000 %b %b %b %b');
                        result[0] = query_utils_1.BCD2int(jsbi_1.default.toNumber(result[0]));
                        result[1] = query_utils_1.BCD2int(jsbi_1.default.toNumber(result[1]));
                        result[2] = query_utils_1.BCD2int(jsbi_1.default.toNumber(result[2]));
                        result[3] = query_utils_1.BCD2int(jsbi_1.default.toNumber(result[3]));
                        return [2 /*return*/, result];
                }
            });
        });
    };
    NetMDInterface.prototype.getTrackEncoding = function (track) {
        return __awaiter(this, void 0, void 0, function () {
            var rawValue, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getTrackInfo(track, 0x3080, 0x0700)];
                    case 1:
                        rawValue = _a.sent();
                        result = query_utils_1.scanQuery(utils_1.stringToCharCodeArray(rawValue), '8007 0004 0110 %b %b');
                        return [2 /*return*/, result.map(function (i) { return jsbi_1.default.toNumber(i); })];
                }
            });
        });
    };
    NetMDInterface.prototype.getTrackFlags = function (track) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1806 01201001 %w ff00 00010008', track);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1806 01201001 %?%? 10 00 00010008 %b')[0];
                        return [2 /*return*/, jsbi_1.default.toNumber(res)];
                }
            });
        });
    };
    NetMDInterface.prototype.getDiscCapacity = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, result, res, i, offset, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendHandshake('180810 1000 0100')];
                    case 1:
                        _a.sent();
                        query = query_utils_1.formatQuery('1806 02101000 3080 0300 ff00 00000000');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _a.sent();
                        result = [];
                        res = query_utils_1.scanQuery(reply, '1806 02101000 3080 0300 1000 001d0000 001b 8003 0017 8000 0005 %w %b %b %b 0005 %w %b %b %b 0005 %w %b %b %b');
                        for (i = 0; i < 3; i++) {
                            offset = i * 4;
                            tmp = [
                                query_utils_1.BCD2int(jsbi_1.default.toNumber(res[offset + 0])),
                                query_utils_1.BCD2int(jsbi_1.default.toNumber(res[offset + 1])),
                                query_utils_1.BCD2int(jsbi_1.default.toNumber(res[offset + 2])),
                                query_utils_1.BCD2int(jsbi_1.default.toNumber(res[offset + 3])),
                            ];
                            result.push(tmp);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    NetMDInterface.prototype.getRecordingParameters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1809 8001 0330 8801 0030 8805 0030 8807 00 ff00 00000000');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1809 8001 0330 8801 0030 8805 0030 8807 00 1000 000e0000 000c 8805 0008 80e0 0110 %b %b 4000');
                        return [2 /*return*/, res.map(function (i) { return jsbi_1.default.toNumber(i); })];
                }
            });
        });
    };
    // TODO: saveTrackToStream
    NetMDInterface.prototype.disableNewTrackProtection = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1800 080046 f0030103 2b ff %w', val);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        query_utils_1.scanQuery(reply, '1800 080046 f0030103 2b 00 %?%?');
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDInterface.prototype.enterSecureSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1800 080046 f0030103 80 ff');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        return [2 /*return*/, query_utils_1.scanQuery(reply, '1800 080046 f0030103 80 00')];
                }
            });
        });
    };
    NetMDInterface.prototype.leaveSecureSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1800 080046 f0030103 81 ff');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        return [2 /*return*/, query_utils_1.scanQuery(reply, '1800 080046 f0030103 81 00')];
                }
            });
        });
    };
    NetMDInterface.prototype.getLeafID = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1800 080046 f0030103 11 ff');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1800 080046 f0030103 11 00 %*');
                        return [2 /*return*/, String.fromCharCode.apply(String, __spread(res[0]))];
                }
            });
        });
    };
    NetMDInterface.prototype.sendKeyData = function (ekbid, keychain, depth, ekbsignature) {
        return __awaiter(this, void 0, void 0, function () {
            var chainlen, databytes, keychain_1, keychain_1_1, key, keychains, query, reply;
            var e_2, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        chainlen = keychain.length;
                        databytes = 16 + 16 * chainlen + 24;
                        try {
                            for (keychain_1 = __values(keychain), keychain_1_1 = keychain_1.next(); !keychain_1_1.done; keychain_1_1 = keychain_1.next()) {
                                key = keychain_1_1.value;
                                if (key.length !== 16) {
                                    throw new Error("Each key in the chain needs to have 16 bytes; this one has " + key.length);
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (keychain_1_1 && !keychain_1_1.done && (_a = keychain_1.return)) _a.call(keychain_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        if (depth < 1 || depth > 63) {
                            throw new Error('Supplied depth is invalid');
                        }
                        if (ekbsignature.length !== 24) {
                            throw new Error('Supplied EKB signature length wrong');
                        }
                        keychains = utils_1.concatUint8Arrays.apply(void 0, __spread(keychain));
                        query = query_utils_1.formatQuery('1800 080046 f0030103 12 ff %w %d %d %d %d 00000000 %* %*', databytes, databytes, chainlen, depth, ekbid, keychains, ekbsignature);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _b.sent();
                        return [2 /*return*/, query_utils_1.scanQuery(reply, '1800 080046 f0030103 12 01 %?%? %?%?%?%?')];
                }
            });
        });
    };
    NetMDInterface.prototype.sessionKeyExchange = function (hostnonce) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (hostnonce.length !== 8) {
                            throw new Error('Supplied host nonce length wrong');
                        }
                        query = query_utils_1.formatQuery('1800 080046 f0030103 20 ff 000000 %*', hostnonce);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        return [2 /*return*/, query_utils_1.scanQuery(reply, '1800 080046 f0030103 20 00 000000 %#')[0]];
                }
            });
        });
    };
    NetMDInterface.prototype.sessionKeyForget = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1800 080046 f0030103 21 ff 000000');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        return [2 /*return*/, query_utils_1.scanQuery(reply, '1800 080046 f0030103 21 00 000000')];
                }
            });
        });
    };
    NetMDInterface.prototype.setupDownload = function (contentid, keyenckey, hexSessionKey) {
        return __awaiter(this, void 0, void 0, function () {
            var message, encryptedarg, query, reply;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (contentid.length !== 20) {
                            throw new Error('Supplied Content ID length wrong');
                        }
                        if (keyenckey.length !== 8) {
                            throw new Error('Supplied Key Encryption Key length wrong');
                        }
                        if (hexSessionKey.length !== 16) {
                            throw new Error('Supplied Session Key length wrong');
                        }
                        message = utils_1.concatUint8Arrays(new Uint8Array([1, 1, 1, 1]), contentid, keyenckey);
                        encryptedarg = crypto_js_1.default.DES.encrypt(crypto_js_1.default.lib.WordArray.create(message), crypto_js_1.default.enc.Hex.parse(hexSessionKey), {
                            mode: crypto_js_1.default.mode.CBC,
                            padding: crypto_js_1.default.pad.NoPadding,
                            iv: crypto_js_1.default.enc.Hex.parse('0000000000000000'),
                        });
                        query = query_utils_1.formatQuery('1800 080046 f0030103 22 ff 0000 %*', utils_1.wordArrayToByteArray(encryptedarg.ciphertext));
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        return [2 /*return*/, query_utils_1.scanQuery(reply, '1800 080046 f0030103 22 00 0000')];
                }
            });
        });
    };
    NetMDInterface.prototype.commitTrack = function (tracknum, hexSessionKey) {
        return __awaiter(this, void 0, void 0, function () {
            var authentication, query, reply, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (hexSessionKey.length !== 16) {
                            throw new Error('Supplied Session Key length wrong');
                        }
                        authentication = crypto_js_1.default.DES.encrypt(crypto_js_1.default.enc.Hex.parse('0000000000000000'), crypto_js_1.default.enc.Hex.parse(hexSessionKey), {
                            mode: crypto_js_1.default.mode.ECB,
                            padding: crypto_js_1.default.pad.NoPadding,
                        });
                        return [4 /*yield*/, this.waitForSync()];
                    case 1:
                        _a.sent();
                        query = query_utils_1.formatQuery('1800 080046 f0030103 48 ff 00 1001 %w %*', tracknum, utils_1.wordArrayToByteArray(authentication.ciphertext));
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 2:
                        reply = _a.sent();
                        result = query_utils_1.scanQuery(reply, '1800 080046 f0030103 48 00 00 1001 %?%?');
                        return [4 /*yield*/, this.waitForSync()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    NetMDInterface.prototype.sendTrack = function (wireformat, discformat, frames, pktSize, packets, hexSessionKey, progressCallback) {
        var packets_1, packets_1_1;
        var e_3, _a;
        return __awaiter(this, void 0, void 0, function () {
            var totalBytes, query, reply, swapNeeded, packetCount, writtenBytes, _b, key, iv, data, binpack, packedLength, e_3_1, res, replydata;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (hexSessionKey.length !== 16) {
                            throw new Error('Supplied Session Key length wrong');
                        }
                        totalBytes = pktSize + 24;
                        query = query_utils_1.formatQuery('1800 080046 f0030103 28 ff 000100 1001 ffff 00 %b %b %d %d', wireformat, discformat, frames, totalBytes);
                        return [4 /*yield*/, this.sendQuery(query, false, true)];
                    case 1:
                        reply = _c.sent();
                        query_utils_1.scanQuery(reply, '1800 080046 f0030103 28 00 000100 1001 %?%? 00 %*');
                        return [4 /*yield*/, this.waitForSync()];
                    case 2:
                        _c.sent();
                        swapNeeded = !utils_1.isBigEndian();
                        packetCount = 0;
                        writtenBytes = 0;
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 9, 10, 15]);
                        packets_1 = __asyncValues(packets);
                        _c.label = 4;
                    case 4: return [4 /*yield*/, packets_1.next()];
                    case 5:
                        if (!(packets_1_1 = _c.sent(), !packets_1_1.done)) return [3 /*break*/, 8];
                        _b = packets_1_1.value, key = _b.key, iv = _b.iv, data = _b.data;
                        progressCallback && progressCallback({ totalBytes: totalBytes, writtenBytes: writtenBytes });
                        binpack = void 0;
                        if (packetCount === 0) {
                            packedLength = new Uint8Array(new Uint32Array([pktSize]).buffer);
                            if (swapNeeded) {
                                packedLength.reverse();
                            }
                            binpack = utils_1.concatUint8Arrays(new Uint8Array([0, 0, 0, 0]), packedLength, key, iv, data);
                        }
                        else {
                            binpack = data;
                        }
                        return [4 /*yield*/, this.netMd.writeBulk(binpack)];
                    case 6:
                        _c.sent();
                        packetCount += 1;
                        writtenBytes += data.length;
                        _c.label = 7;
                    case 7: return [3 /*break*/, 4];
                    case 8: return [3 /*break*/, 15];
                    case 9:
                        e_3_1 = _c.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 15];
                    case 10:
                        _c.trys.push([10, , 13, 14]);
                        if (!(packets_1_1 && !packets_1_1.done && (_a = packets_1.return))) return [3 /*break*/, 12];
                        return [4 /*yield*/, _a.call(packets_1)];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        if (e_3) throw e_3.error;
                        return [7 /*endfinally*/];
                    case 14: return [7 /*endfinally*/];
                    case 15:
                        progressCallback && progressCallback({ totalBytes: totalBytes, writtenBytes: writtenBytes });
                        return [4 /*yield*/, this.readReply()];
                    case 16:
                        reply = _c.sent();
                        return [4 /*yield*/, this.netMd.getReplyLength()];
                    case 17:
                        _c.sent();
                        res = query_utils_1.scanQuery(reply, '1800 080046 f0030103 28 00 000100 1001 %w 00 %?%? %?%?%?%? %?%?%?%? %*');
                        replydata = crypto_js_1.default.DES.decrypt(crypto_js_1.default.lib.WordArray.create(res[1]), crypto_js_1.default.enc.Hex.parse(hexSessionKey), {
                            mode: crypto_js_1.default.mode.CBC,
                            iv: crypto_js_1.default.enc.Hex.parse('0000000000000000'),
                        }).toString(crypto_js_1.default.enc.Utf8);
                        return [2 /*return*/, [jsbi_1.default.toNumber(res[0]), replydata.substring(0, 8), replydata.substring(12, 32)]];
                }
            });
        });
    };
    NetMDInterface.prototype.getTrackUUID = function (track) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1800 080046 f0030103 23 ff 1001 %w', track);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1800 080046 f0030103 23 00 1001 %?%? %*');
                        return [2 /*return*/, String.fromCharCode.apply(String, __spread(res[0]))];
                }
            });
        });
    };
    NetMDInterface.maxSyncAttempts = 4;
    NetMDInterface.syncRetryIntervalInMs = 100;
    NetMDInterface.maxInterimReadAttempts = 4;
    NetMDInterface.interimResponseRetryIntervalInMs = 100;
    return NetMDInterface;
}());
exports.NetMDInterface = NetMDInterface;
function retailmac(key, value, iv) {
    if (iv === void 0) { iv = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]); }
    var subkeyA = key.subarray(0, 8);
    var beginning = value.subarray(0, value.length - 8);
    var end = value.subarray(value.length - 8, value.length);
    var step1 = crypto_js_1.default.DES.encrypt(crypto_js_1.default.lib.WordArray.create(beginning), crypto_js_1.default.lib.WordArray.create(subkeyA), {
        mode: crypto_js_1.default.mode.CBC,
        iv: crypto_js_1.default.lib.WordArray.create(iv),
    });
    var iv2 = crypto_js_1.default.enc.Hex.stringify(step1.ciphertext);
    iv2 = iv2.substring(0, iv2.length - 16); // last 8 byte
    var step2 = crypto_js_1.default.TripleDES.encrypt(crypto_js_1.default.lib.WordArray.create(end), crypto_js_1.default.lib.WordArray.create(key), {
        mode: crypto_js_1.default.mode.CBC,
        iv: crypto_js_1.default.enc.Hex.parse(iv2),
    });
    return crypto_js_1.default.enc.Hex.stringify(step2.ciphertext).substring(0, 16);
}
exports.retailmac = retailmac;
var discforwire = (_b = {},
    _b[Wireformat.pcm] = DiscFormat.spStereo,
    _b[Wireformat.lp2] = DiscFormat.lp2,
    _b[Wireformat.l105kbps] = DiscFormat.lp2,
    _b[Wireformat.lp4] = DiscFormat.lp4,
    _b);
var EKBOpenSource = /** @class */ (function () {
    function EKBOpenSource() {
    }
    EKBOpenSource.prototype.getRootKey = function () {
        // prettier-ignore
        return new Uint8Array([
            0x12, 0x34, 0x56, 0x78, 0x9a, 0xbc, 0xde, 0xf0,
            0x0f, 0xed, 0xcb, 0xa9, 0x87, 0x65, 0x43, 0x21
        ]);
    };
    EKBOpenSource.prototype.getEKBID = function () {
        return 0x26422642;
    };
    EKBOpenSource.prototype.getEKBDataForLeafId = function () {
        // prettier-ignore
        return [
            [
                new Uint8Array([0x25, 0x45, 0x06, 0x4d, 0xea, 0xca, 0x14, 0xf9, 0x96, 0xbd, 0xc8, 0xa4, 0x06, 0xc2, 0x2b, 0x81]),
                new Uint8Array([0xfb, 0x60, 0xbd, 0xdd, 0x0d, 0xbc, 0xab, 0x84, 0x8a, 0x00, 0x5e, 0x03, 0x19, 0x4d, 0x3e, 0xda]),
            ],
            9,
            new Uint8Array([
                0x8f, 0x2b, 0xc3, 0x52, 0xe8, 0x6c, 0x5e, 0xd3, 0x06, 0xdc, 0xae, 0x18,
                0xd2, 0xf3, 0x8c, 0x7f, 0x89, 0xb5, 0xe1, 0x85, 0x55, 0xa1, 0x05, 0xea
            ])
        ];
    };
    return EKBOpenSource;
}());
exports.EKBOpenSource = EKBOpenSource;
var MDTrack = /** @class */ (function () {
    function MDTrack(title, format, data, chunkSize, fullWidthTitle, encryptPacketsIterator) {
        this.title = title;
        this.format = format;
        this.data = data;
        this.chunkSize = chunkSize;
        this.fullWidthTitle = fullWidthTitle;
        this.encryptPacketsIterator = encryptPacketsIterator;
    }
    MDTrack.prototype.getFullWidthTitle = function () {
        return this.fullWidthTitle;
    };
    MDTrack.prototype.getTitle = function () {
        return this.title;
    };
    MDTrack.prototype.getDataFormat = function () {
        return this.format;
    };
    MDTrack.prototype.getFrameCount = function () {
        return this.getTotalSize() / this.getFrameSize();
    };
    MDTrack.prototype.getFrameSize = function () {
        return exports.FrameSize[this.format];
    };
    MDTrack.prototype.getChunkSize = function () {
        return this.chunkSize;
    };
    MDTrack.prototype.getTotalSize = function () {
        var frameSize = this.getFrameSize();
        var len = this.data.byteLength;
        if (len % frameSize !== 0) {
            len = len + (frameSize - (len % frameSize));
        }
        return len;
    };
    MDTrack.prototype.getContentID = function () {
        // prettier-ignore
        return new Uint8Array([
            0x01, 0x0f, 0x50, 0x00, 0x00, 0x04, 0x00, 0x00, 0x00, 0x48,
            0xa2, 0x8d, 0x3e, 0x1a, 0x3b, 0x0c, 0x44, 0xaf, 0x2f, 0xa0,
        ]);
    };
    MDTrack.prototype.getKEK = function () {
        return new Uint8Array([0x14, 0xe3, 0x83, 0x4e, 0xe2, 0xd3, 0xcc, 0xa5]);
    };
    MDTrack.prototype.getPackets = function () {
        // Deprecated. Use getPacketIterator
        var datakey = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
        var firstiv = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
        var datakeyWA = crypto_js_1.default.lib.WordArray.create(datakey);
        var kekWA = crypto_js_1.default.lib.WordArray.create(this.getKEK());
        var key = crypto_js_1.default.DES.encrypt(datakeyWA, kekWA, { mode: crypto_js_1.default.mode.ECB });
        var firstivWA = crypto_js_1.default.lib.WordArray.create(firstiv);
        var dataWA = crypto_js_1.default.lib.WordArray.create(this.data);
        var encrypted = crypto_js_1.default.DES.encrypt(dataWA, key.ciphertext, {
            mode: crypto_js_1.default.mode.CBC,
            iv: firstivWA,
        });
        var encryptedData = utils_1.wordArrayToByteArray(encrypted.ciphertext);
        encryptedData = encryptedData.subarray(0, this.data.byteLength); // CAVEAT: don't know why, but python Crypto returns 8 bytes less that js Crypto
        return [[datakey, firstiv, encryptedData]];
    };
    MDTrack.prototype.getPacketWorkerIterator = function () {
        return this.encryptPacketsIterator({
            kek: this.getKEK(),
            data: this.data,
            frameSize: this.getFrameSize(),
            chunkSize: this.chunkSize,
        });
    };
    MDTrack.prototype.getPacketIterator = function () {
        return __asyncGenerator(this, arguments, function getPacketIterator_1() {
            var iv, ivWA, kekWA, rawKeyWA, keyDec, key, defaultChunkSize, packetCount, chunkSize, uint8DataArray, frameSize, padding, offset, dataChunk, dataChunkWA, encryptedChunk, encryptedDataChunk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        iv = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
                        ivWA = crypto_js_1.default.lib.WordArray.create(iv);
                        kekWA = crypto_js_1.default.lib.WordArray.create(this.getKEK());
                        rawKeyWA = crypto_js_1.default.lib.WordArray.random(8);
                        keyDec = crypto_js_1.default.DES.decrypt({
                            ciphertext: rawKeyWA,
                        }, kekWA, { mode: crypto_js_1.default.mode.ECB, padding: crypto_js_1.default.pad.Pkcs7 });
                        keyDec.sigBytes = 8;
                        key = utils_1.wordArrayToByteArray(keyDec);
                        defaultChunkSize = 0x00100000;
                        packetCount = 0;
                        chunkSize = 0;
                        uint8DataArray = new Uint8Array(this.data);
                        frameSize = this.getFrameSize();
                        if (uint8DataArray.length % frameSize !== 0) {
                            padding = frameSize - (uint8DataArray.length % frameSize);
                            uint8DataArray = utils_1.concatUint8Arrays(uint8DataArray, new Uint8Array(Array(padding).fill(0)));
                        }
                        offset = 0;
                        _a.label = 1;
                    case 1:
                        if (!(offset < uint8DataArray.length)) return [3 /*break*/, 4];
                        if (packetCount > 0) {
                            chunkSize = defaultChunkSize;
                        }
                        else {
                            chunkSize = defaultChunkSize - 24;
                        }
                        chunkSize = Math.min(chunkSize, uint8DataArray.length - offset);
                        dataChunk = uint8DataArray.subarray(offset, offset + chunkSize);
                        dataChunkWA = crypto_js_1.default.lib.WordArray.create(dataChunk);
                        encryptedChunk = crypto_js_1.default.DES.encrypt(dataChunkWA, rawKeyWA, {
                            mode: crypto_js_1.default.mode.CBC,
                            iv: ivWA,
                        });
                        encryptedDataChunk = utils_1.wordArrayToByteArray(encryptedChunk.ciphertext);
                        encryptedDataChunk = encryptedDataChunk.subarray(0, chunkSize); //encryptedDataChunk.length - 8
                        return [4 /*yield*/, __await([key, iv, encryptedDataChunk])];
                    case 2: //encryptedDataChunk.length - 8
                    return [4 /*yield*/, _a.sent()];
                    case 3:
                        _a.sent();
                        // Next iv
                        ivWA = crypto_js_1.default.lib.WordArray.create(encryptedDataChunk.subarray(encryptedDataChunk.length - 8, encryptedDataChunk.length));
                        iv = utils_1.wordArrayToByteArray(ivWA);
                        offset = offset + chunkSize;
                        packetCount += 1;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return MDTrack;
}());
exports.MDTrack = MDTrack;
var MDSession = /** @class */ (function () {
    function MDSession(md, ekbobject, hexSessionKey) {
        this.md = md;
        this.ekbobject = ekbobject;
        this.hexSessionKey = hexSessionKey;
    }
    MDSession.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, chain, depth, sig, hostnonce, devnonce, nonce;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.md.enterSecureSession()];
                    case 1:
                        _b.sent();
                        _a = __read(this.ekbobject.getEKBDataForLeafId(), 3), chain = _a[0], depth = _a[1], sig = _a[2];
                        return [4 /*yield*/, this.md.sendKeyData(jsbi_1.default.BigInt(this.ekbobject.getEKBID()), chain, depth, sig)];
                    case 2:
                        _b.sent();
                        hostnonce = new Uint8Array(Array(8)
                            .fill(0)
                            .map(function (_) { return Math.round(Math.random() * 255); }));
                        return [4 /*yield*/, this.md.sessionKeyExchange(hostnonce)];
                    case 3:
                        devnonce = _b.sent();
                        nonce = utils_1.concatUint8Arrays(hostnonce, devnonce);
                        this.hexSessionKey = retailmac(this.ekbobject.getRootKey(), nonce);
                        return [2 /*return*/];
                }
            });
        });
    };
    MDSession.prototype.downloadTrack = function (trk, progressCallback) {
        return __awaiter(this, void 0, void 0, function () {
            var dataFormat, _a, track, uuid, ccid;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.hexSessionKey) {
                            throw new Error("Call init first!");
                        }
                        return [4 /*yield*/, this.md.setupDownload(trk.getContentID(), trk.getKEK(), this.hexSessionKey)];
                    case 1:
                        _b.sent();
                        dataFormat = trk.getDataFormat();
                        return [4 /*yield*/, this.md.sendTrack(dataFormat, discforwire[dataFormat], trk.getFrameCount(), trk.getTotalSize(), trk.getPacketWorkerIterator(), this.hexSessionKey, progressCallback)];
                    case 2:
                        _a = __read.apply(void 0, [_b.sent(), 3]), track = _a[0], uuid = _a[1], ccid = _a[2];
                        return [4 /*yield*/, this.md.cacheTOC()];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, this.md.setTrackTitle(track, trk.title)];
                    case 4:
                        _b.sent();
                        if (!trk.fullWidthTitle) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.md.setTrackTitle(track, trk.fullWidthTitle, true)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [4 /*yield*/, this.md.syncTOC()];
                    case 7:
                        _b.sent();
                        return [4 /*yield*/, this.md.commitTrack(track, this.hexSessionKey)];
                    case 8:
                        _b.sent();
                        return [2 /*return*/, [track, uuid, ccid]];
                }
            });
        });
    };
    MDSession.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.hexSessionKey !== undefined)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.md.sessionKeyForget()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        this.hexSessionKey = undefined;
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this.md.leaveSecureSession()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return MDSession;
}());
exports.MDSession = MDSession;
//# sourceMappingURL=netmd-interface.js.map